import * as React from "react";
import { Skeleton } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const CCCLineItemLoader = () => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(
    Skeleton,
    {
      "data-t": "ccc-line-loader",
      height: "100%",
      width: "100%",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": getLabel("common.loadingText")
    },
    /* @__PURE__ */ React.createElement("rect", { width: "30%", height: "100%", rx: "5", fill: "currentColor" }),
    /* @__PURE__ */ React.createElement("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor", x: "35%" }),
    /* @__PURE__ */ React.createElement("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor", x: "35%", y: "30" }),
    /* @__PURE__ */ React.createElement("rect", { width: "25%", height: "15px", rx: "5", fill: "currentColor", x: "35%", y: "60" })
  );
};
export {
  CCCLineItemLoader as default
};
//# sourceMappingURL=CCCLineItemLoader.js.map
